import { flux } from '@/core/flux.module';
import { ModelPayload } from '@/tools/models/model.store';
import { ModelOutputV1 } from '@/sdk';
import { ModelType } from '@/tools/models/model.types';

export function resetModel(modelType: ModelType) {
  flux.dispatch(`${modelType}_MODEL_RESET_MODEL`);
}

export function setModel(modelType: ModelType, model: ModelPayload | ModelOutputV1) {
  flux.dispatch(`${modelType}_MODEL_SET_MODEL`, { model });
}
